import { render, staticRenderFns } from "./IconFac.vue?vue&type=template&id=25ed69bb&scoped=true&"
import script from "./IconFac.vue?vue&type=script&lang=js&"
export * from "./IconFac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed69bb",
  null
  
)

export default component.exports